import React from "react";
import "./MenuModal.css";

function MenuModal({
  onClose,
  onIntroductionClick,
  onCreateCustomClick,
  onScoreClick,
  onFaqClick,
  onShareClick,
  onContactClick,
  onProfileButtonClick,
  onRemindersClick,
  onBattleClick,
  menuTexts,
  langString,
  currentUser,
  profileDefault,
  profileAvatarUrl,
  isNative,
  showRemindersRedDot = false,
  showAboutContact = true,
}) {
  return (
    <>
      <div className="menu-overlay" onClick={(e) => {
        if (e.target === e.currentTarget) {
          e.stopPropagation();
          onClose();
        }
      }} />
      <div
        className="menu-modal"
      >
        <button className="menu-close" onClick={onClose} aria-label="Close menu">
          ✕
        </button>
        <div className="menu-card-container">
          <div className="menu-card">
            <button className="menu-option" onClick={onIntroductionClick}>
              {menuTexts.introduction}
            </button>
            {isNative && (
              <button 
                className="menu-option" 
                onClick={onRemindersClick}
                style={{ position: "relative" }}
              >
                {langString === "nl" ? "HERINNERINGEN" : "REMINDERS"}
                {showRemindersRedDot && (
                  <div
                    style={{
                      position: "absolute",
                      top: "8px",
                      right: "8px",
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      backgroundColor: "#ff0000",
                      zIndex: 10,
                    }}
                  />
                )}
              </button>
            )}
            <button className="menu-option" onClick={onScoreClick}>
              {langString === "nl" ? "SCORE & COMPETITIES" : "SCORE & COMPETITIONS"}
            </button>
            {onBattleClick && (
              <button className="menu-option menu-option-battle" onClick={onBattleClick}>
                {langString === "nl" ? "BATTLE" : "BATTLE"}
              </button>
            )}
            <button className="menu-option" onClick={onCreateCustomClick}>
              {menuTexts.primaryCreate}
            </button>
            <button className="menu-option" onClick={onFaqClick}>
              {menuTexts.faq}
            </button>
            <button className="menu-option" onClick={onShareClick}>
              {langString === "nl" ? "DEEL" : "SHARE"}
            </button>
            {showAboutContact && (
              <button className="menu-option" onClick={onContactClick}>
                {langString === "nl" ? "OVER WORDHIT / CONTACT" : "ABOUT WORDHIT / CONTACT"}
              </button>
            )}
          </div>
          <button className="menu-profile-button" onClick={onProfileButtonClick}>
            {currentUser ? (
              <>
                <img
                  src={profileAvatarUrl || profileDefault}
                  alt="Profile"
                  className="menu-profile-avatar"
                />
                <div className="menu-profile-details">
                  <span className="menu-profile-label" />
                  <span className="menu-profile-name">
                    {currentUser.get("name") ||
                      currentUser.get("username") ||
                      currentUser.get("email") ||
                      menuTexts.signIn}
                  </span>
                </div>
              </>
            ) : (
              <span className="menu-profile-cta">{menuTexts.signIn}</span>
            )}
          </button>
        </div>
      </div>
    </>
  );
}

export default MenuModal;

